var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var autocomplete = require('js-autocomplete');
var indicator = require('ordinal/indicator');
var stable = require('stable');
var slugify = require('../utils/slugify.js');
var updateUrlParameter = require('../utils/updateUrlParameter.js');

function Rankings(el) {
  var $el = $(el),
      $rankings = $el.find('#rankings'),
      $chartFilter = $el.find('#chart-industry-filter'),
      $industryFilter = $el.find('#industry-filter'),
      $issueSort = $el.find('#issue-sort'),
      $componentSort = $el.find('#component-sort'),
      $componentOptions = $el.find('#component-sort-options'),
      $compareBar = $el.find('#compare-bar'),
      $dataYear = $el.attr('data-year'),
      $companyData = '/wp-content/themes/justcapital/assets/data/companies.json',
      $industryData = '/wp-content/themes/justcapital/assets/data/industries.json',
      $issuesData = '/wp-content/themes/justcapital/assets/data/methodology_metadata.json',
      $archive = (window.location.pathname === '/rankings/') ? false : true,
      $allCompanies = {},
      $prevYearCompanies,
      $currentView = {},
      $chartView = {},
      $ranked = [],
      $dataClarification = [],
      $bottom = [],
      $chartIndustry = null,
      $industries = {},
      $issues = {},
      $pagination = 1,
      $limit = $pagination,
      $rankOrder = 'asc',
      $abcOrder = 'asc',
      $activeOrder = 'rank',
      $issue = '',
      $industry = '',
      $bottomShown = false,
      $comparing = [],
      $tieFix = [],
      $tieRank = null,
      $prevIssueScore = null,
      $overallTop = $el.find('#intro-overall'),
      $industryTop = $el.find('#intro-industry'),
      $issueTop = $el.find('#intro-issue');

  if ($archive) {
    $companyData = '/wp-content/themes/justcapital/assets/data/companies-' + $dataYear + '.json';
    $industryData = '/wp-content/themes/justcapital/assets/data/industries-' + $dataYear + '.json';
  } else {
    $.getJSON($issuesData, function(issues) {
      $issues = issues;
      $issues.forEach(function(issue) {
        var $issueKey = issue.website_id,
            $components = '';
        $issueSort.find('ul').append('<li><a href="#" data-val="' + $issueKey + '.overall">' + issue.name + '</a></li>');
        issue.components.forEach(function(component) {
          var $componentKey = component.component,
              $metrics = '';
          component.metrics.forEach(function(metric) {
            $metrics += '<li><a href="#" data-val="' + $issueKey + '.' + $componentKey + '.' + metric.website_id + '">' + metric.name + '</a></li>';
          });
          $components += '<li><a href="#" data-val="' + $issueKey + '.' + $componentKey + '.overall">' + component.shortname + '</a><ul>' + $metrics + '</ul></li>';
        });
        $componentOptions.append('<ul data-issue="' + issue.website_id + '"><li><a href="#" data-val="">All Issues & Metrics</a></li>' + $components + '</ul>');
      });
    });
  }

  // Initial view setup
  $.getJSON($companyData, function(data) {
    $allCompanies = data;
    $currentView = $allCompanies;

    $.getJSON($industryData, function(industries) {
      for (var i = 0; i < industries.length; i++) {
        var industry = industries[i],
            $industryName = industry.name,
            $industrySummary = industry.summary ? industry.summary : '';
        $industries[$industryName] = industry.total;
        if ($industryName !== 'JUST 100') {
          $el.find('#industry-filter, #chart-industry-filter').find('ul').append('<li><a href="#" data-val="' + slugify($industryName) + '">' + $industryName + '</a></li>');
          $('#industry-summaries').append('<li data-industry="' + slugify($industryName) + '">' + $industrySummary + '</li>');
        }
      }

      if ($archive) {
        initializeRankings();
      } else {
        var $prevYearData = '/wp-content/themes/justcapital/assets/data/companies-' + (parseInt($dataYear) - 1) + '.json';
        $.getJSON($prevYearData, function(data) {
          $prevYearCompanies = data;
          initializeRankings();
        });
      }
    });

    // Put all the company names, industries and ticker symbols
    // in an array that will go into search suggestions
    var $companyNames = [];
    for (var i = 0, length = $allCompanies.length; i < length; i++) {
      $companyNames.push([$allCompanies[i].ticker, $allCompanies[i].name, $allCompanies[i].industry]);
    }
    // Alphabetize the company names
    function alphabetize(y,x) {
      return y[1].localeCompare(x[1]);
    }
    stable.inplace($companyNames, alphabetize);

    new autocomplete({
      selector: 'input[name=rankings-search]',
      minChars: 0,
      source: function(term, suggest) {
        term = term.toLowerCase();
        var choices = $companyNames,
            suggestions = [];
        for (i = 0; i < choices.length; i++)
          if (~(choices[i][1]+' '+choices[i][0]).toLowerCase().indexOf(term)) suggestions.push(choices[i]);
        suggest(suggestions);
      },
      renderItem: function(item, search) {
        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
        return '<div class="autocomplete-suggestion" data-ticker="'+item[0]+'" data-val="'+item[1]+'">' + item[1].replace(re, "<b>$1</b>") + '<span>'+item[2]+'</span>' + '</div>';
      },
      onSelect: function(e, term, item) {
        e.preventDefault();
        window.location.href = window.location.origin + '/companies/' + slugify(item.getAttribute('data-val'));
      }
    });
  });

  // Sticky bits
  var $sidebar = $('.rankings-sidebar'),
      $sidebarTop = $sidebar.offset().top,
      $headerRow = $('.rankings-headers'),
      $headerRowHeight = $headerRow.outerHeight(),
      $container = $('.rankings-list');

  function stickTools() {
    var $windowTop = $(window).scrollTop(),
        $windowWidth = $(window).outerWidth(),
        $containerWidth = $container.outerWidth(),
        $containerTop = $container.offset().top,
        $containerLeft = $container.offset().left,
        $sidebarWidth = $sidebar.outerWidth(),
        $sidebarHeight = $sidebar.outerHeight(),
        $stickyTop = $('header').outerHeight(),
        $stopAt = $containerTop + $container.outerHeight() - ($('.rankings li:last-child').outerHeight() * 1.5) - $sidebarHeight - $headerRowHeight - $stickyTop,
        $offset = $sidebarHeight + $stickyTop;

    if ($windowWidth >= 992) {
      $stopAt = $containerTop + $container.outerHeight() - $sidebarHeight - $stickyTop;
      $offset = $stickyTop;
    }

    if ($windowTop > $sidebarTop - $stickyTop) {
      $sidebar.addClass('sticky');
      $headerRow.addClass('sticky');
      if ($windowWidth >= 992) {
        $sidebar.css('left', $containerWidth + $containerLeft - $sidebarWidth);
        $headerRow.css({
          'left': $('.rankings-explorer').offset().left,
          'width': $('.rankings-explorer').width()
        });
      } else {
        $sidebar.css('left', 0);
        $headerRow.css({
          'left': 0,
          'width': '100%'
        });
      }
      if ($windowTop > $stopAt) {
        if ($windowWidth >= 992) {
          $stopAt = $stopAt - $sidebarHeight;
          $sidebar.css('left', $containerWidth - $sidebarWidth);
        }
        $sidebar.addClass('sticky-end').css('top', $stopAt + $stickyTop);
        $headerRow.addClass('sticky-end').css({
          'left': 0,
          'top': $stopAt + $offset
        });
      } else {
        $sidebar.removeClass('sticky-end').css('top', $stickyTop);
        $headerRow.removeClass('sticky-end').css('top', $offset);
      }
    } else {
      $sidebar.removeClass('sticky').css('top', 'auto');
      $headerRow.removeClass('sticky');
      if ($windowWidth >= 992) $sidebar.css('left', 'auto');
    }
  }

  $(window).scroll(function() {
    stickTools();
  });

  $(window).resize(function() {
    stickTools();
  });

  $('#show-more').on('click', function(e) {
    e.preventDefault();
    $pagination++;
    $limit = $pagination;
    showRankings();
  });

  $('#show-all').on('click', function(e) {
    e.preventDefault();
    $pagination++;
    $limit = Math.ceil($allCompanies.length / 100);
    showRankings();
  });

  $('#reorder-rank').on('click', function(e) {
    e.preventDefault();
    if(!is_locked)
    {
      $('#reorder-name .fa').addClass('inactive');
      $(this).find('.fa').removeClass('inactive').toggleClass('desc');
      if ($rankOrder === 'asc') {
        $rankOrder = 'desc';
      } else {
        $rankOrder = 'asc';
      }
      $activeOrder = 'rank';
      rankReorder($rankOrder);
      $pagination = 1;
      if (!$issue && !$industry) $bottomShown = false;
      $rankings.empty();
      showRankings();
    }
  });

  $('#reorder-name').on('click', function(e) {
    e.preventDefault();
    if(!is_locked)
    {
      $('#reorder-rank .fa').addClass('inactive');
      $(this).find('.fa').removeClass('inactive').toggleClass('desc');
      if ($abcOrder === 'asc') {
        function abc(x,y) {
          return y.name.localeCompare(x.name);
        }
        stable.inplace($currentView, abc);
        $abcOrder = 'desc';
      } else {
        function zyx(x,y) {
          return x.name.localeCompare(y.name);
        }
        stable.inplace($currentView, zyx);
        $abcOrder = 'asc';
      }
      $activeOrder = 'abc';
      $pagination = 1;
      $bottomShown = true;
      $rankings.empty();
      showRankings();
    }
  });

  // Hide filter/sort dropdowns
  $(document).click(function(){
    $('.custom-select > ul').hide();
  });

  // Clicks within the dropdown won't bubble up past the dropdown element
  $(".custom-select").click(function(e){
    e.stopPropagation();
  });

  $('.custom-select').on('click', 'p', function() {
    // Expand dropdown options
    $('.custom-select > ul').hide();
    $(this).next().show();
  }).on('click', 'a', function(e) {
    e.preventDefault();
    // when an option is selected, change the selected value
    var $select = $(this).closest('.custom-select'),
        $selectType = $select.attr('data-type'),
        $val = $(this).attr('data-val'),
        $text = ($val === 'leaders') ? 'Industry Leaders' : $(this).text();
    $select.find('p').attr('data-val', $(this).attr('data-val')).text($text);
    $select.children('ul').hide();
    if ($selectType === 'issue' || $selectType === 'component') {
      if ($selectType === 'issue') clearFilter($('#component-clear'), $componentSort, 'Issues');
      sortByIssue();
    }
    if ($selectType === 'industry') filterByIndustry();
    if ($selectType === 'chart') filterCharts();
  });

  $('#issue-clear').on('click', function(e) {
    e.preventDefault();
    clearFilter($(this), $issueSort, 'Stakeholders');
    clearFilter($('#component-clear'), $componentSort, 'Issues');
    $('#component-sort-section').hide();
    updateUrl('component', '');
    updateUrl('metric', '');
    sortByIssue();
  });

  $('#component-clear').on('click', function(e) {
    e.preventDefault();
    clearFilter($(this), $componentSort, 'Issues');
    sortByIssue();
  });

  $('#industry-clear').on('click', function(e) {
    e.preventDefault();
    clearFilter($(this), $industryFilter, 'Industries');
    filterByIndustry();
  });

  $('#chart-industry-clear').on('click', function(e) {
    e.preventDefault();
    $chartView = $allCompanies;
    $industryTop.hide();
    $overallTop.show();
    clearFilter($(this), $el.find('#chart-industry-filter'), 'Industries');
    showCharts();
  });

  $('#clear-all').on('click', function(e) {
    e.preventDefault();
    if ($('#issue-clear')) {
      clearFilter($('#issue-clear'), $issueSort, 'Stakeholders');
      sortByIssue();
    }

    clearFilter($('#industry-clear'), $industryFilter, 'Industries');

    filterByIndustry();
  });

  $el.on('click', '.js-show-components', function(e) {
    e.preventDefault();
    var $issue = $(this).closest('.rankings-chart-issue'),
        $issueKey = $issue.attr('data-issue'),
        $issueName = $issue.find('.rankings-chart-issue-name').text();
    $el.find('#stakeholder-charts').hide();
    $el.find('#issue-charts .data__feature span').text($issueName);
    $el.find('#issue-charts').show();
    drawBarCharts($issueKey);
    $('html, body').animate({
      scrollTop: $el.offset().top
    }, 300);
    $issueTop.find('h2').text($issueName);
    $issueTop.find('#issue-summaries li[data-issue="' + $issueKey + '"]').show();
    $overallTop.hide();
    $issueTop.show();
  });

  $el.find('.js-close-components').on('click', function(e) {
    e.preventDefault();
    $el.find('#issue-charts').hide().find('.rankings-chart-issue').remove();
    $el.find('#stakeholder-charts .barcode-chart-scores').empty();
    $el.find('#stakeholder-charts').show();
    showCharts();
    $issueTop.hide();
    if (!$chartFilter.find('p').attr('data-val')) $overallTop.show();
  });

  $el.on('click', '.js-show-metrics', function(e) {
    e.preventDefault();
    var $issue = $(this).closest('.rankings-chart-issue'),
        $issueKey = $issue.attr('data-issue'),
        $componentKey = $issue.attr('data-component'),
        $componentName = $issue.find('.rankings-chart-issue-name').text();
    $el.find('#issue-charts').hide();
    $el.find('#metric-charts .data__feature span').text($componentName);
    $el.find('#metric-charts').show();
    drawBarCharts($issueKey, $componentKey);
    $('html, body').animate({
      scrollTop: $el.offset().top
    }, 300);
  });

  $el.find('.js-close-metrics').on('click', function(e) {
    e.preventDefault();
    $el.find('#metric-charts').hide().find('.rankings-chart-issue').remove();
    $el.find('#issue-charts .barcode-chart-scores').empty();
    $el.find('#issue-charts').show();
    showCharts();
  });

  // Toggle list/chart view
  $el.find('.rankings-toggle').on('click', 'a', function(e) {
    e.preventDefault();
    $(this).siblings('a').removeClass('active');
    $('.rankings-' + $(this).siblings('a').text()).hide();
    $(this).addClass('active');
    $('.rankings-' + $(this).text()).show();
    if ($(this).text() === 'chart') {
      $el.find('.rankings-chart-tools').show();
      // Initial view
      if ($el.find('#stakeholder-charts .rankings-chart-issue').length === 1) {
        $chartView = $allCompanies;
        drawBarCharts();
        var just100 = $allCompanies.find(function(company) {
          return company.rank.overall == 100;
        });
        $el.find('#stakeholder-charts .rankings-chart-issue[data-issue="overall"] .barcode-chart').append('<span class="just-100" style="left: ' + just100.scores.overall + '%; width: ' + (100 - just100.scores.overall) + '%;"></span>');
      }
      if ($issue) $issueTop.hide();
      if ($industry && $industry !== 'leaders') {
        var $selected = $chartFilter.find('a[data-val=' + $industry + ']');
        $chartFilter.find('p').attr('data-val', $industry).text($selected.text());
        filterCharts();
      } else {
        if ($chartFilter.find('p').attr('data-val')) {
          filterCharts();
        } else {
          $industryTop.hide();
          $overallTop.show();
        }
      }
    } else {
      $el.find('.rankings-chart-tools').hide();
      toggleViewSummary();
    }
  });

  // Toggle filter/sort panels (mobile)
  $el.find('.rankings-tools__toggle').on('click', function(e) {
    e.preventDefault();
    $(this).next().show();
    if ($(this).hasClass('compare-mode-toggle')) {
      $el.find('#compare-bar, .rankings-headers__compare, .rankings__compare').show();
    }
  });
  $el.find('.js-close').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.rankings-tools__option').hide();
    if ($compareBar.is(':visible')) {
      $el.find('#compare-bar, .rankings-headers__compare, .rankings__compare').hide();
    }
  });

  // Toggle compare mode (desktop)
  $el.find('.toggle').on('click', function() {
    var $toggle = $(this).find('input');
    $toggle.prop('checked', !$toggle.prop('checked'));
    $compareBar.toggle();
    if ($toggle.prop('checked')) {
      $el.find('#compare-bar, .rankings-headers__compare, .rankings__compare').show();
    } else {
      $el.find('#compare-bar, .rankings-headers__compare, .rankings__compare').hide();
    }
  });

  $el.on('change', '.rankings__compare input', function() {
    updateCompareBar($(this).val().replace('compare-', ''));
  });

  $compareBar.on('click', 'li a', function(e) {
    e.preventDefault();
    var $ticker = $(this).parent().attr('data-co');
    $el.find('#rankings li[data-co=' + $ticker + '] input').prop('checked', false);
    updateCompareBar($ticker);
  });

  function updateCompareBar(ticker) {
    if ($comparing.length <= 3) {
      if ($comparing.indexOf(ticker) >= 0) {
        $compareBar.find('li[data-co=' + ticker + ']').remove();
        $comparing.splice($comparing.indexOf(ticker), 1);
      } else {
        var $name = $el.find('#rankings li[data-co=' + ticker + '] .rankings__company p:first-child').text();
        $compareBar.find('ul').append('<li data-co="' + ticker + '"><a href="#">' + $name + '</a></li>');
        $comparing.push(ticker);
      }
      $compareBar.find('#compare-link').attr('href', '/compare?co=' + $comparing.toString());
    }
    if ($comparing.length === 3) {
      $('.rankings__compare input:not(:checked)').attr('disabled', true);
    } else {
      $('.rankings__compare input').attr('disabled', false);
    }
  }

  function returnToTop() {
    if ($(window).scrollTop() >= $('.rankings-section').offset().top) {
      $('html, body').animate({
        scrollTop: $('.rankings-section').offset().top
      }, 300);
    }
  }

  function updateUrl(key, val) {
    if (history.pushState) {
      var $newUrl = updateUrlParameter(window.location.href, key, val);
      window.history.pushState({path: $newUrl}, '', $newUrl);
    }
  }

  function filterCharts() {
    $chartIndustry = $chartFilter.find('p').attr('data-val');
    if ($chartIndustry) {
      var $chartIndustryName = $chartFilter.find('p').text();
      $chartView = $allCompanies.filter(function(co) {
        return co.industry === $chartIndustryName;
      });
      showCharts();
      $industryTop.find('h2').text($chartIndustryName);
      $industryTop.find('#industry-summaries li[data-industry="' + $chartIndustry + '"]').show();
      $overallTop.hide();
      $industryTop.show();
      $chartFilter.prev().find('.clear-filter').show();
    } else {
      $chartFilter.prev().find('.clear-filter').hide();
    }
  }

  function filterByIndustry() {
    $industry = $industryFilter.find('p').attr('data-val');
    var params = getParams();
    var $paramsIssue = params['issue'];
    var $paramsComponent = params['component'];
    var $paramsMetric = params['metric'];

    $currentView = $allCompanies;
    $pagination = 1;
    $limit = 1;
    toggleViewSummary();
    resetColSorts();

    if ($industry) {
      if ($industry === 'leaders' && ($paramsIssue != "" && $paramsIssue != undefined)) {
        if (($paramsComponent == "" || $paramsComponent == undefined) && ($paramsMetric == "" || $paramsMetric == undefined)){
          $currentView = $allCompanies.filter(function(co) {
            return co.rank[$paramsIssue]['industry'] == 1;
          });
        } else if (($paramsIssue != "" && $paramsIssue != undefined) && ($paramsMetric == "" || $paramsMetric == undefined)) {
          $currentView = $allCompanies.filter(function(co) {
            return co.rank[$paramsIssue][$paramsComponent]['industry'] == 1;
          });
        } else {
          $currentView = $allCompanies.filter(function(co) {
            return co.rank[$paramsIssue][$paramsComponent][$paramsMetric]['industry'] == 1;
          });
        }
      } 
      else if ($industry === 'leaders') {
        $currentView = $allCompanies.filter(function(co) {
          return co.rank.industry == 1;
        });
      } else {
        $currentView = $allCompanies.filter(function(co) {
          return co.industry === $industryFilter.find('p').text();
        });
      }
      $bottomShown = true;
      $industryFilter.prev().find('.clear-filter').show();
    } else {
      $industryFilter.prev().find('.clear-filter').hide();
    }
    if ($issue) sortByIssue();
    $rankings.empty();
    showRankings();
    returnToTop();
    updateUrl('industry', $industry);
  }

  function clearFilter(button, filter, text) {
    button.hide();
    filter.find('p').attr('data-val', '').text('All ' + text);
  }

  function clarification() {
    $ranked = [];
    $dataClarification = [];
    $bottom = [];
    for (var i = 0; i < $currentView.length; i++) {
      var company = $currentView[i];
      if (!company.rank.overall && !$industry && !$issue) {
        $bottom.push(company);
      } else {
        if (company.rank.overall) {
          var $clarification = false;
          if (company.data_clarification) {
            if ($issue) {
              var $clarificationMetric = company.data_clarification.datapoints[0].toLowerCase();
              if ($issue.split('.')[1] === 'overall') {
                if ($issue.split('.')[0] === $clarificationMetric.split('.')[0]) $clarification = true;
              } else {
                if ($issue.split('.')[2] === 'overall') {
                  if ($issue.split('.')[1] === $clarificationMetric.split('.')[1]) $clarification = true;
                } else {
                  if ($issue.split('.')[2] === $clarificationMetric.split('.')[2]) $clarification = true;
                }
              }
            } else {
              $clarification = true;
            }
          }
          if ($clarification) {
            company.specialStatus = 'Data Clarification';
            $dataClarification.push(company);
          } else {
            company.specialStatus = '';
            $ranked.push(company);
          }
        } else {
          $bottom.push(company);
        }
      }
    }
  }

  function sortByIssue() {
    $component = $componentSort.find('p').attr('data-val');
    $issue = $issueSort.find('p').attr('data-val');
    $limit = $pagination;
    $pagination = 1;
    $prevIssueScore = null;
    $tieRank = null;
    $tieFix = [];

    if ($component && $component.split('.')[0] === $issue.split('.')[0]) $issue = $component;

    toggleViewSummary();
    resetColSorts();

    if (!$industry) {
      $currentView = $allCompanies
    } 
    else if ($industry == 'leaders' && ($issue == "" || $issue == undefined)) {
      $currentView = $allCompanies.filter(function(co) {
        return co.rank.industry == 1;
      });
    }
    else if ($industry == 'leaders' && ($issue != "" && $issue != undefined)) {
      if ($issue.split('.')[1] == 'overall'){
        var $selectedStakeholder = $issue.split(".")[0];
        $currentView = $allCompanies.filter(function(co) {
          return co.rank[$selectedStakeholder]['industry'] == 1;
        });
      } else if ($issue.split('.')[2] == 'overall') {
        var $selectedStakeholder = $issue.split(".")[0];
        var $selectedIssue = $issue.split(".")[1];
        $currentView = $allCompanies.filter(function(co) {
          return co.rank[$selectedStakeholder][$selectedIssue]['industry'] == 1;
        });
      } else {
        var $selectedStakeholder = $issue.split(".")[0];
        var $selectedIssue = $issue.split(".")[1];
        var $selectedMetric = $issue.split(".")[2];
        $currentView = $allCompanies.filter(function(co) {
          return co.rank[$selectedStakeholder][$selectedIssue][$selectedMetric]['industry'] == 1;
        });
      }
      
    };

    function rankSort(x,y) {
      return x.rank.overall - y.rank.overall;
    }
    function bottomSort(x,y) {
      return x.name.localeCompare(y.name);
    }

    clarification();
    stable.inplace($ranked, rankSort);
    stable.inplace($dataClarification, bottomSort);
    stable.inplace($bottom, bottomSort);
    $currentView = $ranked.concat($dataClarification).concat($bottom);

    if ($issue) {
      function issue(x,y) {
        if ($issue.split('.')[1] === 'overall') {
          return y.scores[$issue.split('.')[0]][$issue.split('.')[1]] - x.scores[$issue.split('.')[0]][$issue.split('.')[1]];
        } else {
          return y.scores[$issue.split('.')[0]][$issue.split('.')[1]][$issue.split('.')[2]] - x.scores[$issue.split('.')[0]][$issue.split('.')[1]][$issue.split('.')[2]];
        }
      }
      if ($dataClarification) {
        var $rankable = $ranked.concat($bottom);
        stable.inplace($rankable, issue);
        if ($rankOrder === 'asc') {
          $currentView = $rankable.concat($dataClarification);
        } else {
          $currentView = $dataClarification.concat($rankable);
        }
      } else {
        stable.inplace($currentView, issue);
      }
      $bottomShown = true;
      $issueSort.prev().find('.clear-filter').show();
      $componentSort.find('ul').remove();
      $componentOptions.find('ul[data-issue=' + $issue.split('.')[0] + ']').clone().appendTo($componentSort);
      $('#component-sort-section').show();
      updateUrl('issue', $issue.split('.')[0]);
      if ($issue.split('.')[1] !== 'overall') {
        $('#component-clear').show();
        updateUrl('component', $issue.split('.')[1]);
        if ($issue.split('.')[2] === 'overall') {
          updateUrl('metric', '');
        } else {
          updateUrl('metric', $issue.split('.')[2]);
        }
      } else {
        $('#component-clear').hide();
        updateUrl('component', '');
        updateUrl('metric', '');
      }
    } else {
      if (!$industry) $bottomShown = false;
      $issueSort.prev().find('.clear-filter').hide();
      clearFilter($('#component-clear'), $componentSort, 'Issues');
      $('#component-sort-section').hide();
      updateUrl('issue', '');
    }

    $rankings.empty();
    showRankings();
    returnToTop();
  }

  function rankReorder(dir) {
    clarification();
    function bottomSort(x,y) {
      return x.name.localeCompare(y.name);
    }
    stable.inplace($bottom, bottomSort);
    if (dir === 'asc') {
      function rankSortAsc(x,y) {
        if ($issue)
          if ($issue.split('.')[1] === 'overall') {
            return y.scores[$issue.split('.')[0]][$issue.split('.')[1]] - x.scores[$issue.split('.')[0]][$issue.split('.')[1]];
          } else {
            return y.scores[$issue.split('.')[0]][$issue.split('.')[1]][$issue.split('.')[2]] - x.scores[$issue.split('.')[0]][$issue.split('.')[1]][$issue.split('.')[2]];
          }
        if ($industry)
          return x.rank.industry - y.rank.industry;
        return x.rank.overall - y.rank.overall;
      }
      stable.inplace($ranked, rankSortAsc);
      $currentView = $ranked.concat($dataClarification).concat($bottom);
    } else {
      function rankSortDesc(x,y) {
        if ($issue)
          if ($issue.split('.')[1] === 'overall') {
            return x.scores[$issue.split('.')[0]][$issue.split('.')[1]] - y.scores[$issue.split('.')[0]][$issue.split('.')[1]];
          } else {
            return x.scores[$issue.split('.')[0]][$issue.split('.')[1]][$issue.split('.')[2]] - y.scores[$issue.split('.')[0]][$issue.split('.')[1]][$issue.split('.')[2]];
          }
        if ($industry)
          return y.rank.industry - x.rank.industry;
        return y.rank.overall - x.rank.overall;
      }
      stable.inplace($ranked, rankSortDesc);
      $currentView = $dataClarification.concat($bottom).concat($ranked);
    }
  }

  function resetColSorts() {
    $el.find('.rankings-headers__company .fa').removeClass('desc').addClass('inactive');
    $el.find('.rankings-headers__left-col .fa').removeClass('desc').removeClass('inactive');
    $activeOrder = 'rank';
    $rankOrder = 'asc';
    $abcOrder = 'asc';
  }

  function getCompany(company, index) {
    var $ticker = company.ticker,
        $rank = company.rank.overall ? parseInt(company.rank.overall) : null,
        $rankText = ($rank) ? ((company.data_addendum)?'<span class="rank" style="line-height:20px;"><span style="font-size: 1rem;color: #ffa700;">DATA CLARIFICATION</span><span style="font-size: 0.8rem; display: block;line-height: 0.9rem;">'+((typeof company.data_addendum.short_description != 'undefined')?company.data_addendum.short_description:'')+'</span></span>':'<span class="rank">' + $rank + '<span class="hidden-lg">' + indicator($rank) + ' overall</span></span>') : ('<span class="rank--bottom">Bottom 10%</span>'),
        $industryRank = parseInt(company.rank.industry),
        $topSeal = ($rank && $rank <= 100) ? '<p class="seal"><span><strong>JUST 100</strong> ' + $dataYear + '</span></p>' : '',
        $industrySeal = ($industryRank === 1) ? '<p class="seal"><span><strong>Industry Leader</strong> ' + $dataYear + '</span></p>' : '',
        $link = '/companies/' + slugify(company.name),
        $companyItem = '',
        $awardsAndDemerits = '<div class="rankings__seals"><div class="rankings__seal rankings__seal--100">' + $topSeal + '</div><div class="rankings__seal rankings__seal--industry">' + $industrySeal + '</div></div>',
        $index = ($activeOrder == 'rank' && $rankOrder == 'desc') ? $currentView.length - index : index + 1;
        $leftCol = $rankText,
        $rightCol = '<span class="rank--filter rank--filter-default">' + $industryRank + '</span> of ' + $industries[company.industry] + ' <span class="hidden-lg">in industry</span>';

    if ($archive && $dataYear === '2018') {
      var $underReview = ['Cardinal Health', 'McKesson', 'AmerisourceBergen', 'CVS Health', 'Rite Aid', 'Walgreens Boots Alliance'];
      if ($underReview.indexOf(company.name) > -1) $awardsAndDemerits = '<p class="rankings__review">Under Review</p>';
    }

    if(company.under_review)
    {
      $awardsAndDemerits = '<p class="rankings__review">Under Review</p>';
    }

    if(company.unique_event)
    {
      $awardsAndDemerits = '<p class="rankings__review"><svg width="35" height="35" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg" style="float:right;margin-right:15px;"><circle cx="41" cy="41" r="41" fill="#DA0707"></circle><rect x="6" y="6" width="70" height="70" rx="35" fill="#FFEFEF"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M34.6094 17.9894C37.4818 13.3975 44.5182 13.3975 47.3907 17.9894L66.4723 48.4933C67.9583 50.8687 67.7639 53.5823 66.4723 55.6469C65.1911 57.6952 62.8547 59.0909 60.0817 59.0909H21.9183C19.1453 59.0909 16.809 57.6952 15.5277 55.6469C14.2361 53.5823 14.0418 50.8687 15.5277 48.4933L34.6094 17.9894ZM44.1502 20.059C42.7823 17.8723 39.2177 17.8723 37.8498 20.059L18.7681 50.5629C18.1339 51.5769 18.2045 52.6763 18.7681 53.5773C19.342 54.4947 20.451 55.2174 21.9183 55.2174H60.0817C61.5491 55.2174 62.658 54.4947 63.2319 53.5773C63.7955 52.6763 63.8662 51.5769 63.2319 50.5629L44.1502 20.059ZM41 24.5527C42.0586 24.5527 42.9168 25.4198 42.9168 26.4894V40.2075C42.9168 41.2771 42.0586 42.1443 41 42.1443C39.9414 42.1443 39.0833 41.2771 39.0833 40.2075V26.4894C39.0833 25.4198 39.9414 24.5527 41 24.5527ZM41 47.3089C42.0586 47.3089 42.9168 48.1761 42.9168 49.2457V50.3755C42.9168 51.4451 42.0586 52.3122 41 52.3122C39.9414 52.3122 39.0833 51.4451 39.0833 50.3755V49.2457C39.0833 48.1761 39.9414 47.3089 41 47.3089Z" fill="#DA0707"></path></svg></p>';
    }

    // Tiebreakers!
    if ($issue) {
      if ($issue.split('.')[1] === 'overall') {
        $issueScore = company.scores[$issue.split('.')[0]][$issue.split('.')[1]];
      } else {
        $issueScore = company.scores[$issue.split('.')[0]][$issue.split('.')[1]][$issue.split('.')[2]];
      }
      if ($issueScore === $prevIssueScore && $index !== 1) {
        if (!$tieRank) {
          if ($activeOrder == 'rank' && $rankOrder == 'desc') {
            $tieRank = $prevIssueScore ? $index + 1 : $index;
          } else {
            $tieRank = $prevIssueScore ? $index - 1 : $index;
          }
          $tieFix.push($ticker);
        }
        $index = $tieRank;
      } else {
        $tieRank = null;
      }
      $prevIssueScore = $issueScore;
    }

    if (company.specialStatus) {
      $leftCol = '<span class="rank--clarification">' + company.specialStatus + '</span>';
      $rightCol = '';
    } else {
      if ($industry) {
        if ($issue && $industry == 'leaders') {
          var $industryIssueRank = $issue.split('.')[1] == 'overall' ? parseInt(company.rank[$issue.split('.')[0]]['industry']) : $issue.split('.')[2] == 'overall' ? parseInt(company.rank[$issue.split('.')[0]][$issue.split('.')[1]]['industry']) : parseInt(company.rank[$issue.split('.')[0]][$issue.split('.')[1]][$issue.split('.')[2]]['industry']),
          $leftCol = '<span class="rank--filter">' + $industryIssueRank + '</span> of ' + $industries[company.industry] + ' <span class="hidden-lg">in industry</span>';
        }
        else if ($issue) {
          $leftCol = '<span class="rank--filter">' + $index + '</span> of ' + $industries[company.industry] + ' <span class="hidden-lg">in industry</span>';
        } else {
          $leftCol = '<span class="rank--filter">' + $industryRank + '</span> of ' + $industries[company.industry] + ' <span class="hidden-lg">in industry</span>';
        }
        $rightCol = $rankText;
      } else if ($issue) {
        $leftCol = '<span class="rank">' + $index + '</span>';
        $rightCol = $rankText;
      }
    }

    // Show change from previous year
    var $yoy = '';
    if (!$issue && !$archive) {
      $prevYearCompanies.forEach(function(c) {
        if (c.ticker === $ticker && company.rank.overall && c.rank.overall) {
          if (+c.rank.overall == +company.rank.overall) {
            // $yoy = '<span class="rank--change rank--change-equal"></span>';
          } else if (+c.rank.overall > +company.rank.overall) {
            // $yoy = '<span class="rank--change rank--change-up"></span>';
          } else {
            // $yoy = '<span class="rank--change rank--change-down"></span>';
          }
        }
      });
    }

    var $tieLabel = ($tieRank && !company.specialStatus) ? '<span class="rank--label">Tied</span>' : '';
    $leftCol = $yoy + $tieLabel + $leftCol;

    if (!$rank && !$issue && !$bottomShown) {
      $companyItem += '<li class="rankings__note">Overall ranking and scores are not displayed for the lowest-performing 10 percent of companies in our analysis. These companies are displayed in alphabetical order.</li>';
      $bottomShown = true;
    }

    if ($archive) {
      $companyItem += '<li data-co="' + $ticker + '">'
      $companyItem += '<div class="rankings__compare">'
      $companyItem += '<p class="checkbox">'
      $companyItem += '<input type="checkbox" id="compare-' + $ticker + '" name="compare" value="compare-' + $ticker + '">'
      $companyItem += '<label for="compare-' + $ticker + '">Compare</label>'
      $companyItem += '</p>'
      $companyItem += '</div>'
      $companyItem += '<div class="rankings__content">'
      $companyItem += '<p class="rankings__left-col">' + $leftCol + '</p>'
      $companyItem += '<p class="rankings__logo"><img src="/wp-content/themes/justcapital/assets/img/company-logos/' + $ticker + '.png" alt="" /></p>'
      $companyItem += '<div>'
      $companyItem += '<div class="rankings__company">'
      $companyItem += '<p>' + company.name + '</p>'
      $companyItem += '<p>' + company.industry + '</p>'
      $companyItem += '</div>' 
      $companyItem += $awardsAndDemerits 
      $companyItem += '<p class="rankings__right-col">' + $rightCol + '</p>'
      $companyItem += '</div>'
      $companyItem += '</li>';
    } else {
      $companyItem += '<li data-co="' + $ticker + '">'
      $companyItem += '<div class="rankings__compare">'
      $companyItem += '<p class="checkbox">'
      $companyItem += '<input type="checkbox" id="compare-' + $ticker + '" name="compare" value="compare-' + $ticker + '">'
      $companyItem += '<label for="compare-' + $ticker + '">Compare</label>'
      $companyItem += '</p>'
      $companyItem += '</div>'
      $companyItem += '<a class="rankings__content" href="' + $link + '">'
      $companyItem += '<p class="rankings__left-col">' + $leftCol + '</p>'
      $companyItem += '<p class="rankings__logo"><img src="/wp-content/themes/justcapital/assets/img/company-logos/' + $ticker + '.png" alt="" /></p>'
      $companyItem += '<div>'
      $companyItem += '<div class="rankings__company">'
      $companyItem += '<p>' + company.name + '</p>'
      $companyItem += '<p>' + company.industry + '</p>'
      $companyItem += '</div>'
      $companyItem += $awardsAndDemerits 
      if(!is_locked)
      {
        $companyItem += '<p class="rankings__right-col">' + $rightCol + '</p>'  
      }
      $companyItem += '<p class="rankings__button"><span>View Details</span></p>'
      $companyItem += '</div>'
      $companyItem += '</a>'
      $companyItem += '</li>';
    }

    return $companyItem;
  }

  function drawBarCharts(issueKey, componentKey) {
    $issues.forEach(function(issue) {
      if (issueKey) {
        if (issue.website_id === issueKey) {
          issue.components.forEach(function(component) {
            if (componentKey) {
              if (component.component === componentKey) {
                component.metrics.forEach(function(metric) {
                  $el.find('#metric-charts').append('<div class="rankings-chart-issue" data-issue="' + issueKey + '" data-component="' + componentKey + '" data-metric="' + metric.website_id + '"><div class="rankings-chart-summary"><p class="rankings-chart-issue-name">' + metric.name + '</p></div><div class="barcode-chart"><ul class="barcode-chart-scale"><li>0</li><li>25</li><li>50</li><li>75</li><li>100</li></ul><ul class="barcode-chart-scores"></ul></div></div>');
                });
              }
            } else {
              var $metricsLink = component.metrics.length ? '<p><a href="#" class="js-show-metrics">View metrics</a></p>' : '';
              $el.find('#issue-charts').append('<div class="rankings-chart-issue" data-issue="' + issueKey + '" data-component="' + component.component + '" data-metric="overall"><div class="rankings-chart-summary"><p class="rankings-chart-issue-name">' + component.name + '</p><p>' + component.description + '</p>' + $metricsLink + '</div><div class="barcode-chart"><ul class="barcode-chart-scale"><li>0</li><li>25</li><li>50</li><li>75</li><li>100</li></ul><ul class="barcode-chart-scores"></ul></div></div>');
            }
          });
        }
      } else {
        $el.find('#stakeholder-charts').append('<div class="rankings-chart-issue" data-issue="' + issue.website_id + '" data-component="overall"><div class="rankings-chart-summary"><p class="rankings-chart-issue-name">' + issue.name + '</p><p>' + issue.excerpt + '</p><p><a href="#" class="js-show-components">View issues</a></p></div><div class="barcode-chart"><ul class="barcode-chart-scale"><li>0</li><li>25</li><li>50</li><li>75</li><li>100</li></ul><ul class="barcode-chart-scores"></ul></div></div>');
      }
    });
    setTimeout(function() {
      showCharts();
    }, 100);
  }

  function showCharts() {
    var $currentChart = $el.find('.rankings-chart-group:visible');
    $currentChart.find('.rankings-chart-issue').each(function() {
      var $chartIssue = $(this).attr('data-issue'),
          $chartComponent = $(this).attr('data-component'),
          $chartMetric = $(this).attr('data-metric'),
          $issueName = $(this).find('.rankings-chart-issue-name').text(),
          $issueLabel = $currentChart.attr('id').replace('-charts', '');
          $issueLabel = $issueLabel.charAt(0).toUpperCase() + $issueLabel.slice(1),
          $issueRank = $chartView.length,
          $chartBars = '';
      function scoreSort(x,y) {
        if ($chartIssue === 'overall') return x.scores.overall - y.scores.overall;
        if ($chartMetric) {
          return x.scores[$chartIssue][$chartComponent][$chartMetric] - y.scores[$chartIssue][$chartComponent][$chartMetric];
        }
        return x.scores[$chartIssue][$chartComponent] - y.scores[$chartIssue][$chartComponent];
      }
      stable.inplace($chartView, scoreSort);
      $chartView.forEach(function(co) {
        var $chartScore = '',
            $tooltipInfo = '';
        if ($chartMetric) {
          $chartScore = co.scores[$chartIssue][$chartComponent][$chartMetric];
        } else {
          $chartScore = ($chartIssue === 'overall') ? co.scores.overall : co.scores[$chartIssue][$chartComponent];
        }
        if ($chartScore) {
          if ($chartScore < 0) $chartScore = 0;
          if ($chartScore > 100) $chartScore = 100;
          if ($chartIssue === 'overall') {
            if (co.data_clarification) {
              $tooltipInfo = '<p class="barcode-tooltip-note">Data clarification</p>';
            } else {
              $tooltipInfo = '<ul><li><span>' + parseFloat($chartScore).toFixed(2) + '</span> Overall score</li><li><span>' + co.rank.overall + '<sub>' + indicator(co.rank.overall) + '</sub></span> Overall</li><li><span>' + co.rank.industry + '<sub>' + indicator(co.rank.industry) + '</sub></span> in industry</li></ul>';
            }
          } else {
            var $clarification;
            if (co.data_clarification) {
              var $clarificationMetric = co.data_clarification.datapoints[0].toLowerCase();
              if ($chartMetric && $chartMetric !== 'overall') {
                if ($chartMetric === $clarificationMetric.split('.')[2]) $clarification = true;
              } else {
                if ($chartComponent === 'overall' && $chartIssue === $clarificationMetric.split('.')[0]) {
                  $clarification = true;
                } else {
                  if ($chartComponent === $clarificationMetric.split('.')[1]) $clarification = true;
                }
              }
            }
            if ($clarification) {
              $tooltipInfo = '<p class="barcode-tooltip-note">Data clarification</p>';
            } else {
              var $industryLabel = '',
                  $overallScore = '<li><span>' + parseFloat(co.scores.overall).toFixed(2) + '</span> Overall score</li>';
              if (!co.scores.overall) $overallScore = '<li class="bottom"><p>Bottom 10%</p> Overall Score</li>';
              if ($chartIndustry) $industryLabel = 'in industry in ';
              $tooltipInfo = '<ul>' + $overallScore + '<li><span>' + parseFloat($chartScore).toFixed(2) + '</span> ' + $issueLabel + ' score</li><li><span>' + $issueRank + '<sub>' + indicator($issueRank) + '</sub></span> '  + $industryLabel + $issueLabel + ' rank</li></ul>';
              $issueRank--;
            }
          }
          var $chartClass = ($chartIssue === 'overall' && co.rank.overall <= 100) ? 'top-100' : '',
              $tooltipClasses = ($chartScore > 75) ? 'barcode-tooltip issue align-right' : 'barcode-tooltip issue';
          $chartBars += '<li class="' + $chartClass + '" style="left: ' + $chartScore + '%;"><div class="' + $tooltipClasses + '"><a href="/companies/' + slugify(co.name) + '"><p class="barcode-tooltip-top"><img src="/wp-content/themes/justcapital/assets/img/company-logos/' + co.ticker + '.png" alt="" />' + co.name + '</p><div class="barcode-tooltip-ranks"><p>2020 JUST Rankings</p>' + $tooltipInfo + '</div></a></div></li>';
        }
      });

      if ($chartIssue === 'overall') {
        var $bottom10 = ["36.54", "38.01", "38.36", "38.65", "38.92", "38.97", "39.0", "39.06", "39.14", "39.2", "39.24", "39.53", "39.66", "39.9", "39.92", "39.95", "39.98", "40.22", "40.23", "40.31", "40.4", "40.41", "40.49", "40.9", "40.93", "41.02", "41.13", "41.27", "41.45", "41.92", "41.92", "42.08", "42.08", "42.25", "42.26", "42.29", "42.29", "42.3", "42.32", "42.33", "42.34", "42.38", "42.39", "42.43", "42.45", "42.49", "42.51", "42.56", "42.58", "42.58", "42.61", "42.62", "42.65", "42.74", "42.75", "42.83", "42.83", "42.83", "42.84", "42.85", "42.87", "42.95", "43.0", "43.08", "43.08", "43.09", "43.14", "43.15", "43.23", "43.3", "43.31", "43.43", "43.44", "43.44", "43.46", "43.47", "43.48", "43.5", "43.52", "43.53", "43.56", "43.6"];
        $bottom10.forEach(function(x) {
          $chartBars += '<li style="left: ' + x + '%;"><div class="barcode-tooltip bottom"><p>Bottom 10%</p><p>This company is ranked in the bottom 10% of companies overall. We don\'t display overall rankings or scores for the bottom 10%.</p></div></li>';
        });
      }

      $(this).find('.barcode-chart-scores').html($chartBars);
    });
  }

  function getParams() {
    var params = new Array();
    var self = window.location.toString();
    if (window.location.search) {
      var querystring = self.split("?");
      if (querystring.length > 1) {
        var pairs = querystring[1].split("&");
        for (i in pairs) {
          var keyval = pairs[i].split("=");
          params[keyval[0]] = keyval[1];
        }
      }
    }
    return params;
  }

  function initializeRankings() {
    // Load the page with companies preselected
    if (window.location.search) {
      // Get view to show from URL query string params
      var params = new Array();
      var self = window.location.toString();
      var querystring = self.split("?");
      if (querystring.length > 1) {
        var pairs = querystring[1].split("&");
        for (i in pairs) {
          var keyval = pairs[i].split("=");
          params[keyval[0]] = keyval[1];
        }
      }

      if (params['industry']) {
        var $selected = $industryFilter.find('a[data-val=' + params['industry'] + ']'),
            $text = (params['industry'] === 'leaders') ? 'Industry Leaders' : $selected.text();
        $industryFilter.find('p').attr('data-val', params['industry']).text($text);
        filterByIndustry();
      }
      if (params['issue']) {
        var $selectedIssue = params['issue'],
            $selectedComponent = params['component'],
            $selectedMetric = params['metric'],
            $selectedIssueItem = $issueSort.find('a[data-val="' + $selectedIssue + '.overall"]').text();
        $issueSort.find('p').attr('data-val', $selectedIssue + '.overall').text($selectedIssueItem);
        if ($selectedComponent) {
          var $selectedComponentKey = $selectedIssue + '.' + $selectedComponent + '.overall',
              $selectedComponentItem = $componentOptions.find('ul[data-issue=' + $selectedIssue + '] a[data-val="' + $selectedComponentKey + '"]').text();
          $componentSort.find('p').attr('data-val', $selectedComponentKey).text($selectedComponentItem);
        }
        if ($selectedMetric) {
          var $selectedMetricKey = $selectedIssue + '.' + $selectedComponent + '.' + $selectedMetric,
              $selectedMetricItem = $componentOptions.find('ul[data-issue=' + $selectedIssue + '] a[data-val="' + $selectedMetricKey + '"]').text();
          $componentSort.find('p').attr('data-val', $selectedMetricKey).text($selectedMetricItem);
        }
        sortByIssue();
      }
    } else {
      rankReorder($rankOrder);
      showRankings();
    }
  }

  function showRankings() {
    // Display the correct column headings
    if ($industry) {
      if ($issue) {
        if ($issue.split('.')[1] === 'overall'){
          $el.find('#reorder-rank span').text('Stakeholder');
          $el.find('#intro-issue .section-label').text('By Stakeholder');
        } else if ($issue.split('.')[2] === 'overall'){
          $el.find('#reorder-rank span').text('Issue');
          $el.find('#intro-issue .section-label').text('By Issue');
        } else {
          $el.find('#reorder-rank span').text('Metric');
          $el.find('#intro-issue .section-label').text('By Metric');
        }        
      } else {
        $el.find('#reorder-rank span').text('Industry');
      }
      $el.find('.rankings-header__left-col').addClass('filtered');
      $el.find('.rankings-headers__right-col').text('Overall Rank');
    } else if ($issue) {
      if ($issue.split('.')[1] === 'overall'){
        $el.find('#reorder-rank span').text('Stakeholder');
        $el.find('#intro-issue .section-label').text('By Stakeholder');
      } else if ($issue.split('.')[2] === 'overall'){
        $el.find('#reorder-rank span').text('Issue');
        $el.find('#intro-issue .section-label').text('By Issue');
      } else {
        $el.find('#reorder-rank span').text('Metric');
        $el.find('#intro-issue .section-label').text('By Metric');
      }   
      $el.find('.rankings-header__left-col').addClass('filtered');
      $el.find('.rankings-headers__right-col').text('Overall Rank');
    } else {
      $el.find('#reorder-rank span').text('Overall');
      $el.find('.rankings-header__left-col').removeClass('filtered');
      $el.find('.rankings-headers__right-col').text('Industry Rank');
    }

    $('#show-more, #show-all').show();

    var i = ($pagination - 1) * 100,
        total = $currentView.length,
        $items = '';
    for (i; i < ($limit * 100) && i < total; i++) {
      $items += getCompany($currentView[i], i);
      if (i + 1 === total) $('#show-more, #show-all').hide();
    }
    $rankings.append($items).ready(function () {
      for (var t in $tieFix) {
        var $firstTied = $rankings.find('li[data-co="' + $tieFix[t] + '"]').prev();
        if ($firstTied.find('.rankings__left-col .rank--label').length === 0) $firstTied.find('.rankings__left-col').prepend('<span class="rank--label">Tied</span>');
      }
      $rankings.addClass('visible');
    });


    if ($compareBar.is(':visible')) $('.rankings__compare').show();
    for (var i = 0, length = $comparing.length; i < length; i++) {
      $rankings.find('li[data-co=' + $comparing[i] + '] input').prop('checked', true);
    }

    $pagination = $limit;
  }

  function toggleViewSummary() {
    if (!$industry && !$issue) {
      $industryTop.hide();
      $issueTop.hide();
      $overallTop.show();
    } else {
      $overallTop.hide();
      if ($industry) {
        $industryTop.find('h2').text($industryFilter.find('p').text());
        $industryTop.find('#industry-summaries li').hide();
        $industryTop.find('#industry-summaries li[data-industry="' + $industry + '"]').show();
        $industryTop.show();
      } else {
        $industryTop.hide();
      }
      if ($issue) {
        $issues.forEach(function(issue) {
          if (issue.website_id === $issue.split('.')[0]) {
            if ($issue.split('.')[1] === 'overall') {
              $issueTop.find('h2').text(issue.name);
              $issueTop.find('#issue-summaries').html('<p>' + issue.description + ' <a href="/issues/' + slugify(issue.name) + '"><strong>Learn more</strong></a></p>');
            } else {
              issue.components.forEach(function(component) {
                if (component.component === $issue.split('.')[1]) {
                  if ($issue.split('.')[2] === 'overall') {
                    $issueTop.find('h2').text(component.name);
                    $issueTop.find('#issue-summaries').html('<p>' + component.description + ' <a href="/issues/' + slugify(issue.name) + '/' + slugify(component.shortname) + '"><strong>Learn more</strong></a></p>');
                  } else {
                    component.metrics.forEach(function(metric) {
                      if (metric.website_id === $issue.split('.')[2])
                      {
                        $issueTop.find('h2').text(metric.name);
                        $issueTop.find('#issue-summaries').html('');
                      } 
                    });
                  }
                }
              });
            }
          }
        });
        $issueTop.show();
      } else {
        $issueTop.hide();
      }
    }
  }
}

module.exports = Rankings;
